const digitGroupChars = '0123456789'
const consonantGroupChars = 'bcdfghjklmnpqrstvwxz'
const vowelGroupChars = 'aeiouy'
const letterGroupChars = consonantGroupChars + vowelGroupChars
const symbolGroupChars = '@#$()<>[]{}^&~+-*/%=\\?!_.,:;'

function shuffle<T>(input: ReadonlyArray<T>): T[] {
  const result = [...input]
  const randomValues = new Uint16Array(result.length)
  window.crypto.getRandomValues(randomValues)
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor((randomValues[i] / 65536) * (i + 1))
    ;[result[i], result[j]] = [result[j], result[i]]
  }
  return result
}

function selectRandomChars(chars: string, length: number) {
  const array = new Uint16Array(length)
  window.crypto.getRandomValues(array)
  let res = ''
  for (let i = 0; i < length; i++) {
    const r = array[i] % chars.length
    res += chars.substring(r, r + 1)
  }
  return res
}

export function generatePassword(): string {
  const groupedValues = [
    ...selectRandomChars(letterGroupChars, 7),
    ...selectRandomChars(letterGroupChars.toUpperCase(), 8),
    ...selectRandomChars(digitGroupChars, 4),
    ...selectRandomChars(symbolGroupChars, 4),
  ]
  return `${selectRandomChars(letterGroupChars, 1)}${shuffle(groupedValues).join('')}`
}
